import { io } from "socket.io-client";

let socket = null;

// Determine server URL based on environment
const getServerUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:5001";
  }
  return window.location.origin;
};

/**
 * Initialize Socket.IO connection with JWT authentication
 * @param {string} token - JWT access token
 */
export const initializeSocket = (token) => {
  if (socket && socket.connected) {
    console.log("Socket already connected");
    return socket;
  }

  const serverUrl = getServerUrl();

  socket = io(serverUrl, {
    auth: {
      token,
    },
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  socket.on("connect", () => {
    console.log("✅ Socket.IO connected:", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.log("❌ Socket.IO disconnected:", reason);
  });

  socket.on("connect_error", (error) => {
    console.error("Socket connection error:", error.message);
  });

  return socket;
};

/**
 * Disconnect the socket
 */
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
    console.log("Socket disconnected");
  }
};

/**
 * Get the current socket instance
 */
export const getSocket = () => {
  return socket;
};

/**
 * Listen for notification events
 * @param {Function} callback - Function to call when notification is received
 */
export const onNotification = (callback) => {
  if (socket) {
    socket.on("notification", callback);
  }
};

/**
 * Remove notification event listener
 */
export const offNotification = () => {
  if (socket) {
    socket.off("notification");
  }
};
